import { Card, CardContent, Typography, Box, Chip } from "@mui/material";
import { motion } from "framer-motion";
import { Skill } from "../data/skills";

interface SkillCardProps extends Skill {
  index: number;
}

export const SkillCard = ({
  name,
  Icon,
  description,
  index,
}: SkillCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      style={{ height: "100%" }}
    >
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          minHeight: "180px",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: (theme) => theme.shadows[4],
          },
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "flex-start",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              mb: 2,
              "@media (max-width: 700px)": {
                flexDirection: "column",
                textAlign: "center",
                justifyContent: "center",
              },
            }}
          >
            <Box sx={{ color: "primary.main" }}>
              <Icon sx={{ fontSize: 40 }} />
            </Box>
            <Typography
              variant="h6"
              sx={{ color: "secondary.main", fontWeight: "bold" }}
            >
              {name}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {description.map((skill, idx) => (
              <Chip
                key={idx}
                label={skill}
                size="small"
                variant="outlined"
                sx={{
                  borderColor: "primary.main",
                  color: "text.secondary",
                  "&:hover": {
                    backgroundColor: "primary.main",
                    color: (theme) =>
                      theme.palette.mode === "dark"
                        ? "background.paper"
                        : "white",
                  },
                }}
              />
            ))}
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};
